import {
	exportFinalizedOuigoVouchers,
	finalizeOuigoVouchers,
	getEligibleOuigoVouchers,
	getFinalizedOuigoVouchers,
} from '../api';

const getVoucherQuery = ({
	startDate,
	endDate,
	page,
	pageSize,
	sortBy,
} = {}) => ({
	startDate,
	endDate,
	page,
	pageSize,
	sortBy,
});

const getDateRangeQuery = ({ startDate, endDate, sortBy } = {}) => ({
	startDate,
	endDate,
	sortBy,
});

export const getEligibleVouchersApi = (parameters, error, success) =>
	getEligibleOuigoVouchers(getVoucherQuery(parameters), error, success);

export const getFinalizedVouchersApi = (parameters, error, success) =>
	getFinalizedOuigoVouchers(getVoucherQuery(parameters), error, success);

export const finalizeVouchersApi = (vouchers, error, success) =>
	finalizeOuigoVouchers(vouchers, error, success);

export const exportFinalizedVouchersApi = (parameters, error, success) =>
	exportFinalizedOuigoVouchers(getDateRangeQuery(parameters), error, success);
